<template>
    <div class="field">
        <div class="avatar-container">
            <div class="avatar-upload">
                <div class="avatar-edit">
                    <input
                        id="imageEdit"
                        ref="imageEdit"
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        @change="onImageSelected($event)"
                    />
                    <label for="imageEdit"></label>
                </div>
                <div class="avatar-preview">
                    <div
                        ref="imagePreview"
                        class="image-preview"
                        style="background-image: url(/images/no-photo.jpg);"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import exifHandler from '../../common/exif/exifHandler';
import api from '../../common/api';
import url from '../../common/url';
import { Bus, Stops } from '../../common/bus';

export default {
    name: 'ImageContainer',
    props: { pictures: Array, ownerType: String },
    data() {
        return {
            isUploading: false,
            image: null,
            uploadProgess: 100,
            changed: false,
        };
    },
    created() {
        Bus.$on(Stops.UPLOAD_IMAGE, this.uploadImage);
    },
    mounted() {
        if (this.pictures[0]) this.renderPreview(this.pictures[0].small);
    },
    watch: {
        pictures(pic) {
            console.log('changed');
            if (pic[0]) this.renderPreview(pic[0].small);
        },
    },
    methods: {
        async onImageSelected(event) {
            if (!event.target || !event.target.files || !event.target.files[0]) return;
            [this.image] = event.target.files;
            await exifHandler.parse(this.image);
            this.renderFromFile();
            console.log('changed');
            this.changed = true;
        },
        renderFromFile() {
            const reader = new FileReader();
            reader.onload = e => {
                this.renderPreview(e.target.result);
            };
            reader.readAsDataURL(this.image);
        },
        renderPreview(uri) {
            const dom = this.$refs.imagePreview;
            dom.style.display = 'none';
            dom.style.backgroundImage = `url(${uri})`;
            dom.style.display = '';
        },
        async uploadImage(payload) {
            if (!this.changed || !this.image || !payload || !payload.ownerId) return;
            const uri = this.getImageUri(payload.ownerId);
            this.uploadProgess = 0;
            Bus.$emit(Stops.TOAST, 'Uploading image...');
            const reader = new FileReader();
            this.isUploading = true;
            reader.onload = async e => {
                const data = await api.upload(uri, e.target.result, this.onUploadProgress);
                this.isUploading = false;
                if (data.error) {
                    Bus.$emit(Stops.TOAST, 'Image upload failed');
                } else {
                    Bus.$emit(Stops.TOAST, 'Image uploaded');
                }
            };
            reader.readAsArrayBuffer(this.image);
            this.changed = false;
        },
        getImageUri(id) {
            if (this.ownerType === 'catch') return url.getCatchImages(id);
            else if (this.ownerType === 'catcher') return url.getCatcherImages(id);
            else if (this.ownerType === 'region') return url.getRegionImages(id);
            return null;
        },
        onUploadProgress(progressEvent) {
            this.uploadProgess = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        },
    },
};
</script>

<style lang="scss" scoped>
.avatar-container {
    display: flex;
    justify-content: center;
    padding-top: 1rem;
    .avatar-upload {
        position: relative;
        width: 100%;
        max-width: 253px;
        .avatar-edit {
            position: absolute;
            right: 0.8rem;
            z-index: 1;
            top: 0.8rem;
            input {
                display: none;
                + label {
                    display: inline-block;
                    width: 2.1rem;
                    height: 2.1rem;
                    margin-bottom: 0;
                    border-radius: 100%;
                    background: #ffffff;
                    border: 1px solid transparent;
                    box-shadow: 0rem 0.1rem 0.2rem 0rem rgba(0, 0, 0, 0.12);
                    cursor: pointer;
                    font-weight: normal;
                    transition: all 0.2s ease-in-out;
                    &:hover {
                        background: #f1f1f1;
                        border-color: #d6d6d6;
                    }
                    &:after {
                        content: '\f040';
                        font-family: FontAwesome;
                        color: #757575;
                        position: absolute;
                        top: 0.2rem;
                        left: 0.2rem;
                        right: 0rem;
                        text-align: center;
                        margin: auto;
                    }
                }
            }
        }
        .avatar-preview {
            width: 240px;
            height: 240px;
            position: relative;
            border-radius: 100%;
            border: 0.5rem solid #f8f8f8;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            .image-preview {
                opacity: 1;
                transition: all 1s ease-in-out;
            }
            > div {
                width: 100%;
                height: 100%;
                border-radius: 100%;
                background-size: cover;
                background-repeat: no-repeat;
                background-position: center;
            }
        }
    }
}
</style>
